module.exports = __webpack_public_path__ + "media/images/categories/carousel/working-practices-a6e4814dd0308f1527fe07855065ab92.jpg";